//client/src/pages/user/ApiKeys.j
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { toast } from "react-hot-toast";

export default function ApiKeys() {
  const [keys, setKeys] = useState([]);

  const load = async () => {
    const res = await api.get("/api-keys");
    setKeys(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    await api.post("/api-keys");
    toast.success("API key created");
    load();
  };

  const revoke = async (id) => {
    await api.delete(`/api-keys/${id}`);
    toast.success("API key revoked");
    load();
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="text-2xl font-bold">🔑 API Access</h1>

      <button onClick={create} className="btn-primary">
        Generate API Key
      </button>

      <div className="space-y-3">
        {keys.map((k) => (
          <div
            key={k._id}
            className="p-4 bg-black/30 rounded-xl flex justify-between"
          >
            <div>
              <div className="font-mono text-sm">{k.key}</div>
              <div className="text-xs text-gray-400">
                {k.isActive ? "Active" : "Revoked"}
              </div>
            </div>

            {k.isActive && (
              <button
                onClick={() => revoke(k._id)}
                className="text-red-400 text-sm"
              >
                Revoke
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
